<template>
    <div>
        <top @searchApi="searchApi"></top>
        <div class="container">
            <breadcrumb :url="url"></breadcrumb>
        </div>
        <div class="container flex" style="margin-top: 30px;">
            <div class="select" style="margin-bottom: 10px;">
                <Fselect @clickType="clickType"></Fselect>
            </div>
            <div class="goods flex flex-wrap" v-show="isInits">
                <div
                    class="goods-item shdow1"
                    v-for="(item, i) in list"
                    :key="i"
                    @click="jump(item.id)"
                >
                    <div class="goods-img">
                        <img :src="item.image" alt="" class="goods-img_s" />
                    </div>

                    <div class="goods-name flex ali-cen">
                        <div class="goods-tag">修复</div>
                        <div class="goods-name-text">{{ item.title }}</div>
                    </div>
                    <div class="goods-text">
                        {{ item.subtitle }}
                    </div>
                    <div class="goods-price F-flex">
                        <div style="color: #FF6701;font-size: 14px;">
                            ¥{{ item.sku_price[0].price }}
                        </div>
                        <div class="goods-btn">立即购买</div>
                    </div>
                </div>
            </div>
            <div class="GoodsimgNull" v-show="isInit">
                <img src="../../images/null.89b975cb.png" alt="">
            </div>
           
        </div>
        <bottom></bottom>
    </div>
</template>

<script>
import top from "../../components/top.vue";
import breadcrumb from "../../components/breadcrumb.vue";
import Fselect from "../../components/select.vue";
import bottom from "../../components/bottom.vue";
import { category, lists } from "@/api/index.js";
export default {
    data() {
        return {
            url: [{ name: "分类", url: "/type" }],
            list: [],
            search: "",
            userId: "",
            isInit: false,
            isInits:false,
            type:'0'
        };
    },
    beforeCreate() {
        document
            .querySelector("body")
            .setAttribute("style", "background:#f5f5f5");
    },
    created() {
        if (this.$route.query.search) {
             this.search = this.$route.query.search;
             this.type = this.$route.query.type;
        }
        this.lists();
    },
    methods: {
        lists(e = "") {
            console.log(e);
            if (JSON.parse(localStorage.getItem("userInfo"))) {
                this.userId = JSON.parse(localStorage.getItem("userInfo")).user_id;
            } else {
                this.userId = "";
            }
            let searchObj = {};
            lists({
                category_id: e,
                keywords: this.search,
                page: 1,
                uid: this.userId,
                type:this.type
            }).then(res => {
                if(res.code !==1){
                return this.isInit = true
                }
                console.log('res.data.total',res.data.total);
                if(res.data.total==0){
                    console.log('‘显示');
                    this.isInit = true
                    this.isInits = false
                    return
                }
                this.isInit = false
                 this.isInits = true
                this.list = res.data.data;
                
              

                console.log('this.list',this.list);

                // if(res.data.useSn){   
                //      console.log(res.data.data[0].id);
                //      this.$router.push({name:'info',query: {id:res.data.data[0].id,sn:this.search}})
                // }
            });
        },
        clickType(e) {
            console.log(e);
            this.search = "";
            this.lists(e);
        },
        jump(e) {
            this.$router.push({ name: "info", query: { id: e } });
        },
        searchApi(e) {
            this.search = e;
            console.log('this.search',this.search);
            this.lists();
        }
    },

    components: {
        top,
        breadcrumb,
        Fselect,
        bottom
    }
};
</script>

<style lang="less" scoped>
.GoodsimgNull{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}
.shdow1 {
    transition: all 0.2s linear;
}
.shdow1:hover {
    transform: translateX(0) translateY(-5px);
    box-shadow: 0px 9px 31px 0px rgba(0, 0, 0, 0.1);
}
.goods {
    height: 100%;
    .goods-item {
        width: 220px;
        height: 301px;
        background: #ffffff;
        border: 1px solid #d2d2d2;
        padding: 10px;
        margin-left: 16px;
        margin-bottom: 14px;
        cursor: pointer;
        .goods-img {
            width: 207px;
            height: 200px;
            margin-bottom: 10px;
            .goods-img_s {
                width: 100%;
                height: 100%;
            }
        }
        .goods-name {
            font-size: 16px;
            .goods-tag {
                width: 43px;
                height: 15px;
                background: #5db031;
                border-radius: 10px;
                text-align: center;
                font-size: 10px;
                line-height: 15px;
                color: #fff;
            }
            .goods-name-text {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                width: 166px;
            }
        }
        .goods-text {
            font-size: 12px;
            margin: 5px 0;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        .goods-btn {
            width: 70px;
            height: 22px;
            background: #ff6701;
            text-align: center;
            line-height: 22px;
            color: #fff;
            font-size: 12px;
            border-radius: 11px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/index/type.vue